export const PriceMarginPresetLinkCell = ({ value }: { value: any[] }) => {
    return (
        <span>
            {value.map((el) => el.priceMarginPreset?.name ?? "").join("; ")}
        </span>
    )
}
